import { CapacitorConfig } from '@capacitor/cli';

const config: CapacitorConfig = {

  appId: 'com.navikaranait.mfg',
  appName: 'Myfoodgenie',
  webDir: 'dist/multikart/browser',
    plugins: {
      PushNotifications: {
        presentationOptions: ["badge", "sound", "alert"],
      },
      WebView: {
        permissions: ['CAMERA', 'RECORD_AUDIO', 'MODIFY_AUDIO_SETTINGS']
      }
     },
    

   }
export default config;
